export * from './IconExpandWidthCorner';
